<template>
    <a-drawer :title="title" width="500" :maskClosable="false" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
        <a-form-model ref="form" :model="field" :rules="rules" layout="vertical">
            <a-form-model-item label="比赛名称" prop="name">
                <a-input v-model="field.name" placeholder="请填写比赛名称" />
            </a-form-model-item>
            <a-form-model-item label="比赛项目" prop="type">
                <a-select v-model="field.type" placeholder="请选择比赛项目">
                    <a-select-option value="R01" key="R01">注意力猜拳</a-select-option>
                    <a-select-option value="R02" key="R02">舒尔特方格</a-select-option>
                    <a-select-option value="R03" key="R03">虚实线</a-select-option>
                    <a-select-option value="R04" key="R04">中心悬点</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="比赛难度" prop="level">
                <a-radio-group v-model="field.level" button-style="solid">
                    <a-radio-button value="Easy">
                        简单
                    </a-radio-button>
                    <a-radio-button value="Normal">
                        正常
                    </a-radio-button>
                    <a-radio-button value="Hard">
                        困难
                    </a-radio-button>
                </a-radio-group>
            </a-form-model-item>
            <a-form-model-item>
                <a-button type="primary" @click="doSave" icon="save">
                    保存
                </a-button>
                <a-button style="margin-left: 10px;" icon="redo" @click="doReset">
                    重置
                </a-button>
            </a-form-model-item>
        </a-form-model>
    </a-drawer>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: false,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            field: {
                id: '',
                name: '',
                type: 'R01',
                level: 'Easy'
            },
            rules: {
                name: [{ required: true, message: '请填写比赛名称', trigger: 'blur' }],
                type: [{ required: true, message: '请选择比赛项目', trigger: 'change' }],
                level: [{ required: true, message: '请选择比赛难度', trigger: 'change' }]
            }
        }
    },
    mounted() {
        if (this.item.id) {
            Object.keys(this.field).forEach(key => (this.field[key] = this.item[key] != undefined ? this.item[key] : this.field[key] || ''))
        }
    },
    methods: {
        doSave() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.$http.post('/cts/ate/race/mgr/save', this.field).then(result => {
                        if (result.code === 0) {
                            this.$emit('doLoad')
                            this.$emit('update:show', false)
                            this.$message.success('保存成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                    return false
                }
            })
        },
        doReset() {
            this.$refs.form.resetFields()
            this.$refs.form.clearValidate()
            if (this.item.id) {
                Object.keys(this.field).forEach(key => (this.field[key] = this.item[key] != undefined ? this.item[key] : this.field[key] || ''))
            }
        }
    }
}
</script>
